module.exports = __webpack_public_path__ + "static/media/dummy-asset.ae2343f0.png";